var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{style:(_vm.cssDiv),attrs:{"cols":_vm.colsWidth}},[_c('hr',{staticClass:"dividerStyles"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }